import { Badge, Dropdown } from "react-bootstrap";
import { getJeepRallyMediaUrl } from "../../../../../../api/jeep-rally/api";

const TrackMapThumb = ({ route }) => {
  const imageUrl = getJeepRallyMediaUrl(route?.track_map_image);

  if (!imageUrl) {
    return (
      <div
        className="d-flex align-items-center justify-content-center bg-light text-muted"
        style={{
          width: "56px",
          height: "40px",
          borderRadius: "6px",
          border: "1px solid #dee2e6",
          fontSize: "10px",
        }}
      >
        No map
      </div>
    );
  }

  return (
    <img
      src={imageUrl}
      alt={route?.title || "Track map"}
      style={{
        width: "56px",
        height: "40px",
        objectFit: "cover",
        borderRadius: "6px",
        border: "1px solid #dee2e6",
      }}
    />
  );
};

const RoutesTable = ({
  routes,
  onView,
  onEdit,
  onDelete,
  isDeleting,
  canManage,
}) => {
  return (
    <div className="table-responsive">
      <table className="table table-striped mb-0">
        <thead>
          <tr>
            <th style={{ width: 48 }}>#</th>
            <th style={{ width: 72 }}>Map</th>
            <th style={{ minWidth: 140 }}>Title</th>
            <th style={{ width: 130 }}>Distance (km)</th>
            <th style={{ width: 120 }}>Estimated Time</th>
            <th style={{ width: 90 }}>Stages</th>
            <th style={{ width: 100 }}>Status</th>
            <th>Description</th>
            <th className="text-center" style={{ width: 72 }}>
              Actions
            </th>
          </tr>
        </thead>
        <tbody>
          {routes.map((route, index) => {
            const routeId = route._id || route.id;
            const isActive = route.status !== "inactive";
            const stagesCount = Array.isArray(route.stages)
              ? route.stages.length
              : 0;

            return (
              <tr key={routeId || `${index}-${route.title || ""}`}>
                <td>{index + 1}</td>
                <td>
                  <TrackMapThumb route={route} />
                </td>
                <td>{route.title || route.name || "-"}</td>
                <td>{route.total_distance_km ?? "-"}</td>
                <td>{route.estimated_time || "-"}</td>
                <td>{stagesCount}</td>
                <td>
                  <Badge bg={isActive ? "success" : "secondary"}>
                    {route.status || "active"}
                  </Badge>
                </td>
                <td
                  style={{
                    maxWidth: 320,
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                  }}
                >
                  {route.description || "-"}
                </td>
                <td className="text-center align-middle">
                  <Dropdown>
                    <Dropdown.Toggle
                      variant="link"
                      className="p-0 text-decoration-none"
                    >
                      &#x2022;&#x2022;&#x2022;
                    </Dropdown.Toggle>
                    <Dropdown.Menu align="end">
                      <Dropdown.Item
                        onClick={() => onView(route)}
                        disabled={!routeId}
                      >
                        View
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={() => onEdit(route)}
                        disabled={!routeId || !canManage}
                      >
                        Edit
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={() => onDelete(route)}
                        className="text-danger"
                        disabled={!routeId || isDeleting || !canManage}
                      >
                        Delete
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default RoutesTable;
